var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { SkeletonPlaceholderDataContainer, SkeletonPlaceholderOverlay, SkeletonPlaceholderWrapper } from 'app/styles/districtModules/SkeletonPlaceholderStyles';
import SwipeableNewsListSkeleton from 'app/components/topNewsModule/subNews/SwipeableNewsListSkeleton';
import { NewsPerView } from 'app/components/topNewsModule/models/NewsPerView';
import React from 'react';
import styled from 'styled-components';
import { SIZES, Typography } from '@fupa/fupa-uikit';
const DataContainer = styled(SkeletonPlaceholderDataContainer).withConfig({
  componentId: "sc-qvxikc-0"
})(["padding:", ";text-align:center;", ";", ";"], SIZES['16'], props => props.theme.streamLayoutOneColBig(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), SIZES['36']), props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), SIZES['56']));
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-qvxikc-1"
})(["", ";", ";"], props => props.theme.streamLayoutOneColBig(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), SIZES['16']), props => props.theme.desktopLayout(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), SIZES['16']));
const NewsListPlaceholder = () => {
  return /*#__PURE__*/React.createElement(SkeletonPlaceholderWrapper, {
    "data-sentry-element": "SkeletonPlaceholderWrapper",
    "data-sentry-component": "NewsListPlaceholder",
    "data-sentry-source-file": "NewsListPlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(SkeletonPlaceholderOverlay, {
    "data-sentry-element": "SkeletonPlaceholderOverlay",
    "data-sentry-source-file": "NewsListPlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(DataContainer, {
    "data-sentry-element": "DataContainer",
    "data-sentry-source-file": "NewsListPlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(StyledTypography, {
    variant: "body2",
    "data-sentry-element": "StyledTypography",
    "data-sentry-source-file": "NewsListPlaceholder.tsx"
  }, "Es liegen keine weiteren Meldungen in den letzten 7 Tagen vor."))), /*#__PURE__*/React.createElement(SwipeableNewsListSkeleton, {
    numChildren: NewsPerView.Large,
    animation: false,
    "data-sentry-element": "SwipeableNewsListSkeleton",
    "data-sentry-source-file": "NewsListPlaceholder.tsx"
  }));
};
export default NewsListPlaceholder;